import '../../../src/docReady.js';
import isMobile from '../../../src/isMobile.js';
import Helper from '../../../src/Helper.js'; // easing
import './style.scss';

const moduleSelector = '.eiovisual-cf7';

/**
 * Classe esempio
 */
class Module {
    
    // _________________________________________________________________________
    
    constructor() {
        this.run();
        
        Helper.debug('Modulo CF7');
    }

    // _________________________________________________________________________
    
    /**
     * Run di questo block.
     * @returns this
     */
    run() {
        var that = this;

        docReady(() => {
            let $modules = document.querySelectorAll(moduleSelector);

            // avvia il carousel per ogni modulo trovato
            $modules.forEach(($module) => {
                new ModuleFeature($module);
            });
        });
    }
}

class ModuleFeature {
    
    constructor($module) {
        this.$module = $module;
        
        this.init_feature();
    }

    // _________________________________________________________________________

    init_feature() {
        setTimeout(() => { this.task1() },100);
    }
    
    /**
     * Replica i campi
     * @returns {undefined}
     */
    task1() {

        var $replicator = this.$module.querySelector('.replicator');
        var $replicate = this.$module.querySelector('.replicate');
        if($replicate && $replicate.length > 0) {
            var $formControls = $replicate.querySelectorAll('.form-control');
        }

         // init campi
         // per ogni formControl, modifica il name e aggiunge []
         if($formControls && $formControls.length > 0) {
            $formControls.forEach(($formControl,i) => {
                let name = $formControl.getAttribute('name');
                $formControl.setAttribute('name',name + '[]');
            });
        }


        // cliccando sul replicatore clona gli elementi
        if($replicator) {
            $replicator.addEventListener('click',(e) => {
                e.preventDefault();

                // per ogni formControl clona l'elemento e lo appende in fondo al parent del nodo clonato
                $formControls.forEach(($formControl,i) => {
                    let $clonedElement = $formControl.cloneNode(true);
                    $clonedElement.classList.add('mt-3');
                    $formControl.parentNode.appendChild($clonedElement);
                });

            });
        }
    }

}

// export
export default new Module();